import { render, staticRenderFns } from "./period-selector.vue?vue&type=template&id=8e61824c&scoped=true&"
import script from "./period-selector.vue?vue&type=script&lang=js&"
export * from "./period-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e61824c",
  null
  
)

export default component.exports